import { createSlice } from '@reduxjs/toolkit'

export const searchListtSlice = createSlice({
    name: 'searchList',
    initialState: { isLoaded: false, store: [], lastStore: '' },
    reducers: {
        changeIsLoaded: (state, action) => {
            state.isLoaded = action.payload.isLoaded
        },
        saveStoreList: (state, action) => {
            state.store = action.payload.store
        },
        saveLastStore: (state, action) => {
            state.lastStore = action.payload.lastStore
        },
    },
})

export const { changeIsLoaded, saveStoreList, saveLastStore } =
    searchListtSlice.actions
export default searchListtSlice.reducer
